export const APP_ROUTES = Object.freeze({
  home: '/login',
  landing: '/',
  register: '/inscription',
  admin: '/dashboard',
  gestionnaire: '/gestionnaire',
  merchant: '/merchant',
  particulier: '/particulier',
  clientLogin: '/client',
  driver: '/driver/app',
  track: '/track',
  sharePosition: '/pos',
  confirmOrder: '/c',
});

export const LEGACY_ROUTE_REDIRECTS = Object.freeze({
  '/admin': APP_ROUTES.admin,
  '/livreur': APP_ROUTES.driver,
  '/pro': APP_ROUTES.merchant,
  '/suivi': APP_ROUTES.track,
  '/driver': APP_ROUTES.driver,
});

const ADMIN_EMAILS = (process.env.REACT_APP_ADMIN_EMAILS || '')
  .split(',')
  .map((value) => value.trim().toLowerCase())
  .filter(Boolean);

export function isAdminUser(user) {
  if (!user) return false;
  if (String(user.app_metadata?.role || '').toLowerCase() === 'admin') return true;
  return ADMIN_EMAILS.includes(String(user.email || '').toLowerCase());
}
